module.exports = __webpack_public_path__ + "static/media/img-app01.4d1c9e64.png";